// eslint-disable-next-line no-redeclare, @typescript-eslint/no-redeclare
import { Button, Group, Stack, TextInput, Text as MantineText } from '@mantine/core';
import { FC, useContext, useEffect, useState } from 'react';
import validator from 'validator';
import { ModalDialog } from '../../../Molecules/Dialogs';
import { ConstantS } from '../../../Service/ConstantS';
import { ProfileContext } from '../../../Service/Context/ProfileContext';
import { MixpanelS } from '../../../Service/MixpanelS';
import { admitUserOnProfile } from '../../../Service/restapi/authService';

const AddTeamMemberModal: FC<{ show: boolean; toggle: () => void }> = ({ show, toggle }) => {
  const { bookitupTeam } = useContext(ProfileContext);
  const [emailNewShare, setEmailNewShare] = useState('');
  const [loadingShareProfile, setLoadingShareProfile] = useState(false);
  const [invalidEmail, setInvalidEmail] = useState(false);

  useEffect(() => {
    setEmailNewShare('');
    setLoadingShareProfile(false);
    setInvalidEmail(false);
  }, [show]);

  const shareProfile = () => {
    if (!validator.isEmail(emailNewShare)) {
      setInvalidEmail(true);
      return;
    }

    setLoadingShareProfile(true);
    admitUserOnProfile(emailNewShare)
      .then((resp) => {
        if (resp.ok) {
          MixpanelS.track(ConstantS.TrackingEvents.TeamMemberAdded);
          return bookitupTeam.refresh();
        }

        return undefined;
      })
      .catch(() => undefined)
      .finally(() => {
        setLoadingShareProfile(false);
        toggle();
      });
  };

  return (
    <ModalDialog
      header="Teammitglied hinzufügen"
      body={
        <Stack spacing="sm">
          <MantineText size="sm" color="dimmed">
            Gib die E-Mail-Adresse der Person ein, die Zugriff auf dieses Profil erhalten soll. Falls noch kein bookitup
            Konto existiert, wird automatisch ein Zugang erstellt und per E-Mail zugeschickt.
          </MantineText>
          <TextInput
            label="E-Mail"
            value={emailNewShare}
            placeholder="name@example.com"
            error={invalidEmail ? 'Gib eine gültige E-Mail-Adresse ein.' : undefined}
            onChange={(event) => {
              setInvalidEmail(false);
              setEmailNewShare(event.currentTarget.value);
            }}
          />
          <MantineText size="xs" color="dimmed">
            Die Freigabe kannst Du jederzeit wieder auflösen. Nur Du, als Admin des Profils, kannst weitere Freigaben
            einrichten.
          </MantineText>
        </Stack>
      }
      footer={
        <Group position="right">
          <Button variant="default" onClick={toggle}>
            Abbrechen
          </Button>
          <Button loading={loadingShareProfile} onClick={shareProfile}>
            Profil freigeben
          </Button>
        </Group>
      }
      show={show}
      toggle={toggle}
    />
  );
};

export default AddTeamMemberModal;
